export const environment = {
  production: true,
  domainUrl: "https://dashboard.eventcombo.com",
  domainProxyUrl: "https://dashboard.eventcombo.com",
  apiBaseUrl: 'https://dashboard.eventcombo.com/ng-api/',
};
